module.exports = __webpack_public_path__ + "static/media/hour-glass.2c3c9e3b.svg";